import React, {useState} from 'react'
import MyTable from '../components/myTable';
import SiderBarPro from '../components/siderBarPro';
import {  useProSidebar } from 'react-pro-sidebar';
import {useSelector} from 'react-redux';
import '../css/style.css'

function Payment() {
    const marginLeft = useSelector(state => state.style.payload.marginLeft)
  return (
    <div className='main'>
        <MyTable/>
    </div>
  )
}

export default Payment